const LanguagesActionType = {
  FETCH_ALL_LANGUAGES: "ALL_LANGUAGES",
  FETCH_SINGLE_LANGUAGE: "FETCH_SINGLE_LANGUAGE",
};
export default LanguagesActionType;
